var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-video-wrapper"},[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-big-play-centered",attrs:{"preload":"auto","controls":"controls"}},[_c('source',{attrs:{"src":_vm.feed.craw_uri,"type":"video/mp4"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }